export default "__VITE_ASSET__BSpBSvhO__"